<template>
    <div class="mb-5">
        <a v-if="isTaxiCategorySelected()" class="btn btn-primary" href="/es/catalogo/descargar/precios-zona" target="_blank" style="position: fixed; bottom: 20px; right: 20px; z-index: 1000;">
            <span v-if="locale === 'es'">Ver precios por zona</span>
            <span v-if="locale === 'en'">View prices by zone</span>
        </a>
        <Pagination class="d-none d-md-flex" :pages="pages" v-model="page" :total="total" :pageSize="pageSize"/>
        <label for="" class="filter-title-mobile">{{ $locale == 'es' ? 'Filtros' : 'Filters' }}:
        </label>

        <div class="catalog-layout">

            <Filters
                class="col-12 col-sm-12 col-md-3 col-lg-2"
                :filters="filters"
                :locale="locale"
                :configTexts="configTexts"
                :customOrder="config.component === 'Catalog'"
                @getData="getData"
                @resetPage="resetPage"
            />
            <div class="d-flex flex-column col-12 col-sm-12 col-md-9 col-lg-10">
                <Pagination class="d-flex d-md-none" :pages="pages" v-model="page" :total="total" :pageSize="pageSize"/>
                <List ref="list"
                    class=""
                    :config="config"
                    :locale="locale"
                    :configTexts="configTexts"
                    :page="page"
                    :pageSize="pageSize"
                    :metadata="metadata"
                    :status="status"
                    :total="total"
                    :pages="pages"
                    @updateMetadata="updateMetadata"/>
            </div>
            
        </div>

        <Pagination :pages="pages" v-model="page" :total="total" :pageSize="pageSize"/>
        
        <template v-if="configTexts && configTexts.mapText">
            <a class="btn btn-primary d-flex d-md-none flex-nowrap align-items-center justify-content-center mt-4" :href="terminalsUrl">
                <span class="pe-3" v-html="configTexts.mapText"></span> <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon" width="18" height="18">
            </a>
        </template>
        
        <div class="d-flex d-md-none w-100">
            <div class="my-3 w-100" v-if="configTexts && configTexts.banner">
                <div class="banner catalog-banner text-center d-flex flex-row flex-md-column py-2 px-3 px-sm-5 px-md-2 justify-content-center align-items-center">
                    <img v-if="configTexts.banner.image && configTexts.banner.image.value" :src="configTexts.banner.image.value.public_path" class="catalog-img" width="300" height="400"/>
                    <span class="filter-banner-span" v-if="configTexts.banner.text && configTexts.banner.text.value" v-html="configTexts.banner.text.value"/>
                </div>
                <a class="btn btn-secondary d-flex flex-nowrap align-items-center justify-content-center"
                    :href="downloadsUrl"
                    v-if="configTexts.banner.cta && configTexts.banner.cta.value">

                    <span class="pe-3">{{configTexts.banner.cta.value.title}}</span>
                    <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon" width="18" height="18">
                </a>
            </div>
        </div>

    </div>
</template>
<script>
import Filters from './components/Filters.vue'
import List from './components/List.vue'
import Pagination from './components/Pagination.vue';
import _ from 'lodash';

export default {
    props: { 
        filters: {
            type: Array,
            required: true
        },
        config: {
            type: Object,
            default: () => ({})
        },
        locale: String,
        configTexts: Object
    },
    components: { List, Filters, Pagination},
    data: () => ({
        page: 0,
        pageSize: 12,
        metadata: null,
        status: {
            loading: false
        }
    }),
    watch: {
        page: {
            handler: function(newValue) {
                this.getData();
            },
            immediate: true
        },
    },
    computed: {
        total() {
            return Boolean(this.metadata?.total) ? this.metadata.total : null;
        },
        pages() {
            return this.total ? Math.ceil(this.total / this.pageSize) : 0;
        },
        downloadsUrl() {
            return this.locale == 'es' ? 'catalogo/descargar' : 'catalog/download';
        },
        terminalsUrl() {
            return this.locale == 'es' ? 'terminales' : 'terminals';
        }
    },
    methods: {
        getData: _.debounce(function () {
            this.isTaxiCategorySelected();
            this.$refs.list.getData();
        }, 250),
        updateMetadata(metadata) {
          this.metadata = metadata;
        },
        isTaxiCategorySelected() {
            return window.location.href.includes('taxi') ? true : false;
        },
        resetPage() {
            this.page = 0;
        }
    }
}
</script>
<style lang="scss">
.catalog-banner{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}
.catalog-banner >:first-child{
    flex: 1;
    max-width: 150px;
}
.catalog-banner >:last-child{
    flex: 1;
    min-width: 175px;
}
.filter-title-mobile{
    font-size: 16px;
    color: rgb(104, 104, 104);
    margin-bottom: 20px;
    font-weight: 400;
}
.catalog-layout{
    display: flex;
    flex-wrap: nowrap;
    gap: 30px;
    >div:first-of-type{
        min-width: 215px;
        flex: 1;
        max-width: 215px;
    }
    >div{
        flex: 1;
        min-width: 215px;
    }
    @media (max-width: 768px) {
        flex-wrap: wrap;
        >div:first-of-type{
            max-width: 100%
        }
    }
}

</style>